import { BrowserDetectionService } from '@repo/roche-xx-shared';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';
import { MainSearch, MainSearchProps } from './main-search';

const queryClient = new QueryClient();

export const MainSearchView = (props: MainSearchProps): JSX.Element => {
  if (BrowserDetectionService.isBrowserContext()) {
    return (
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <Routes>
            <Route path='*' element={<MainSearch {...props} />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <StaticRouter location='/'>
        <Routes>
          <Route path='*' element={<MainSearch {...props} />} />
        </Routes>
      </StaticRouter>
    </QueryClientProvider>
  );
};
